import { AdminProfileKey } from './admin-profile.model';

export const PII_CAPABILITY = 'pii';

export const ADMIN_PROFILE_KEYS: AdminProfileKey[] = [
  'god-mode',
  'analyst',
  'care-giver',
  'composer',
  'operator',
  'marketer',
];

// Mirror of server/src/auth/authz/profiles.ts — keep the two in sync.
// Pre-migration accounts only carry `level`.
const LEVEL_PROFILE_MAP: Record<string, AdminProfileKey[]> = {
  superuser: ['god-mode'],
  admin: ['god-mode'],
  user: ['analyst', 'care-giver', 'operator', 'marketer'],
  author: ['analyst', 'care-giver', 'operator', 'marketer'],
};

interface PrincipalLike {
  profiles?: string[];
  capabilities?: string[];
  level?: string;
}

export function deriveProfiles(user: PrincipalLike | null | undefined): AdminProfileKey[] {
  if (!user) return [];
  if (Array.isArray(user.profiles) && user.profiles.length) {
    return user.profiles.filter((p): p is AdminProfileKey =>
      ADMIN_PROFILE_KEYS.includes(p as AdminProfileKey),
    );
  }
  return LEVEL_PROFILE_MAP[user.level] ?? [];
}

export function deriveCapabilities(user: PrincipalLike | null | undefined): string[] {
  if (!user) return [];
  if (Array.isArray(user.capabilities)) return user.capabilities;
  return user.level === 'superuser' ? [PII_CAPABILITY] : [];
}
